/**
 * Routes where non-urgent prompts (PWA install, service-worker update) must
 * not render.
 *
 * These screens carry a `sticky bottom-0` footer holding the primary action —
 * "Complete drill" on the live screen, "Save drill record" on wrap-up. Both
 * prompts are `fixed bottom-*` at `z-50` and land directly on top of it. QA
 * measured the update toast covering ~89% of `wrap-up-save`, with
 * `elementFromPoint` at the button centre returning the prompt rather than the
 * button: a staff member finishing a statutory evacuation record could tap and
 * have nothing happen, during a time-pressured safety procedure.
 *
 * Matched on the path SUFFIX because every screen also has org/location-scoped
 * route variants (`/loc/:locId/...`, `/org/:orgId/loc/:locId/...`).
 *
 * The daily-checklist Today page is on the list for the same mechanical
 * reason: its per-tab Save sits at the bottom of the page, and on the shared
 * tablets staff use, the first tap after a deploy or on a fresh device landed
 * on the update / install card instead of Save (seen live on test-cpm,
 * 2026-09-06). History, sign-off and the template editor are not included.
 *
 * Keep this list tight — it is for flows where an interruption is genuinely
 * unsafe or defeats the page's one action, not merely inconvenient.
 */
const SUPPRESSED_PATH_PATTERN = /(\/fire-drills\/[^/]+\/(live|wrap-up)|\/checklists)$/;

export const isPromptSuppressedPath = (pathname: string): boolean =>
  SUPPRESSED_PATH_PATTERN.test(pathname);
